const Menu = [
  {
    title: 'Start',
    group: 'apps',
    name: 'Start',
    icon: 'dashboard',
  },
  {
    title: 'Settings',
    group: 'apps',
    name: 'Settings',
    icon: 'fa-sliders-h',
  },
]

export default Menu
